import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QuickBar = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone) {
      Swal.fire({
        title: "이름, 연락처를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/quick", {
        name: name,
        phone: phone,
        type: "",
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div className="hidden xl:block fixed bottom-0 left-0 w-full h-fit bg-primary z-30">
      <div className="relative w-full h-full grid  grid-cols-5 items-center gap-5 3xl:gap-7 px-[calc((100%-var(--container))/3)] py-2">
        <div className="col-span-2 text-white relative w-fit h-fit flex justify-between items-center gap-3 3xl:gap-5">
          <div className=" relative w-fit h-fit mx-auto">
            <img
              alt="키플레이어 도어락 로고"
              src={"/images/whiteLogo.png"}
              className=" relative w-auto h-full max-h-10 py-0.5 object-contain"
            />
          </div>
          <div className=" relative w-1 h-5 border-r border-white"></div>
          <div className="relative w-fit h-fit flex justify-center items-center gap-2">
            <p>문의전화</p>
            <h4 className="manru 2xl:text-3xl 3xl:text-4xl text-point">
              010.8799.3313
            </h4>
          </div>
        </div>
        <div className="col-span-3 relative w-full h-full flex gap-3 3xl:gap-5">
          <input
            type="text"
            placeholder="이름"
            value={name}
            id="name1"
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="text"
            placeholder="연락처(010-0000-0000)"
            value={phone}
            id="phone1"
            onChange={(e) =>
              setPhone(
                e.target.value
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*)\./g, "$1"),
              )
            }
          />
          <button
            type="button"
            onClick={handlerPostContact}
            disabled={loading}
            className="relative w-fit text-center h-fit pt-2 pb-1 px-6 bg-point"
          >
            <h5 className="font-medium">전송하기</h5>
          </button>
          {/* <div className=" text-white">
            <p className="text-xs">
              문의&nbsp;후&nbsp;30분&nbsp;이내에&nbsp;회신이&nbsp;없다면&nbsp;전화문의&nbsp;부탁드립니다.
            </p>
            <div className="flex items-center gap-1">
              <input
                type="checkbox"
                name="privacy"
                id="privacy"
                defaultChecked
                checked={true}
                className="!w-3 !h-3"
              />
              <label htmlFor="privacy">
                <p className="text-xs 3xl:text-sm">
                  개인정보처리방침&nbsp;동의
                </p>
              </label>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default QuickBar;
